import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { nanoid } from 'nanoid';
import { Grid, makeStyles, Typography } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  regular: {
    '& p': {
      color: theme.palette.grey.dark
    }
  },
  selected: {
    backgroundColor: theme.palette.primary.light,
    boxShadow: `inset -2px 0 0 0 ${theme.palette.primary.main}`,
    '& p': {
      fontWeight: 'bold',
      color: theme.palette.primary.main
    }
  }
}));

const BenchmarkIndexList = ({ count, activeIndex }) => {
  const classes = useStyles();
  const indexes = useMemo(() => [...Array(count).keys()], [count]);

  return indexes.map(index => (
    <Grid
      item
      container
      alignItems="center"
      justify="center"
      key={nanoid(10)}
      className={`${classes.regular} ${index === activeIndex && classes.selected}`}
    >
      <Typography>{index + 1}</Typography>
    </Grid>
  ));
};

BenchmarkIndexList.propTypes = {
  count: PropTypes.number.isRequired,
  activeIndex: PropTypes.number
};

BenchmarkIndexList.defaultProps = {
  activeIndex: null
};

export default BenchmarkIndexList;
